<template>
  <div class="sidebar-wrapper">
    <nav
        :class="{sidebar: true, sidebarStatic, sidebarOpened}"
        @mouseenter="sidebarMouseEnter"
        @mouseleave="sidebarMouseLeave"
    >
      <header class="logo">
        <router-link to="/admin/dashboard">
          <img src="./../../../assets/images/app_icon.png" style="border-radius: 50%" height="30" width="30" alt="app logo"/>
          <span v-if="sidebarOpened" class="primary-word m-1">Ekhoni Daktar</span>
        </router-link>
      </header>
      <ul class="nav">
<!--        <NavLink-->
<!--            :activeItem="activeItem"-->
<!--            header="Dashboard"-->
<!--            link="/admin/dashboard"-->
<!--            iconName="fi flaticon-home"-->
<!--            index="dashboard"-->
<!--            isHeader-->
<!--        />-->
<!--        <NavLink-->
<!--                :activeItem="activeItem"-->
<!--                header="Admin Pannel"-->
<!--                link="/admin/adminpannel"-->
<!--                iconName="fi flaticon-user"-->
<!--                index="adminpannel"-->
<!--                isHeader-->
<!--        />-->
        <NavLink
                :activeItem="activeItem"
                header="Doctor"
                link="/admin/doctor"
                iconName="fa fa-stethoscope"
                index="doctor"
                isHeader
        />
        <NavLink
                :activeItem="activeItem"
                header="User Agents"
                link="/admin/useragents"
                iconName="fa fa-user-md"
                index="useragents"
                isHeader
        />
        <NavLink
                :activeItem="activeItem"
                header="Users"
                link="/admin/users"
                iconName="fa fa-user-md"
                index="users"
                isHeader
        />
        <NavLink
                :activeItem="activeItem"
                header="Appointments"
                link="/admin/appointments"
                iconName="fa fa-calendar-o"
                index="appointments"
                isHeader
        />

        <NavLink
                :activeItem="activeItem"
                header="Free Requests"
                link="/admin/freerequests"
                iconName="fa fa-phone"
                index="free requests"
                isHeader
        />
<!--        <NavLink-->
<!--            :activeItem="activeItem"-->
<!--            header="Tables Basic"-->
<!--            link="/admin/tables"-->
<!--            iconName="fi flaticon-equal-1"-->
<!--            index="tables"-->
<!--            isHeader-->
<!--        />-->
<!--        <NavLink-->
<!--            :activeItem="activeItem"-->
<!--            header="Components"-->
<!--            link="/admin/components"-->
<!--            iconName="fi flaticon-network"-->
<!--            index="components"-->
<!--            :childrenLinks="[-->
<!--              { header: 'Charts', link: '/admin/components/charts' },-->
<!--              { header: 'Icons', link: '/admin/components/icons' },-->
<!--            ]"-->
<!--        />-->
      </ul>
<!--      <p>-->
<!--      <h5 class="navTitle">-->
<!--        LABELS-->
<!--        <a class="actionLink">-->
<!--          <i class="la la-plus float-right"/>-->
<!--        </a>-->
<!--      </h5>-->
<!--      <ul class="sidebarLabels">-->
<!--        <li>-->
<!--          <a href="#">-->
<!--            <i class="fa fa-circle text-danger mr-2"/>-->
<!--            <span class="labelName">My Recent</span>-->
<!--          </a>-->
<!--        </li>-->
<!--        <li>-->
<!--          <a href="#">-->
<!--            <i class="fa fa-circle text-primary mr-2"/>-->
<!--            <span class="labelName">Starred</span>-->
<!--          </a>-->
<!--        </li>-->
<!--        <li>-->
<!--          <a href="#">-->
<!--            <i class="fa fa-circle mr-2"/>-->
<!--            <span class="labelName">Background</span>-->
<!--          </a>-->
<!--        </li>-->
<!--      </ul>-->
<!--      <h5 class="navTitle">-->
<!--        PROJECTS-->
<!--      </h5>-->
<!--      <div class="sidebarAlerts">-->
<!--        <b-alert-->
<!--            v-for="alert in alerts"-->
<!--            :key="alert.id"-->
<!--            class="sidebarAlert" variant="transparent"-->
<!--            show dismissible-->
<!--        >-->
<!--          <span>{{alert.title}}</span><br/>-->
<!--          <b-progress class="sidebarProgress progress-xs mt-1"-->
<!--                      :variant="alert.color" :value="alert.value" :max="100"/>-->
<!--          <small>{{alert.footer}}</small>-->
<!--        </b-alert>-->
<!--      </div>-->
    </nav>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import isScreen from '@/core/screenHelper';
import NavLink from './NavLink/NavLink';

export default {
  name: 'Sidebar',
  components: { NavLink },
  data() {
    return {
      alerts: [
        {
          id: 0,
          title: 'Sales Report',
          value: 15,
          footer: 'Calculating x-axis bias... 65%',
          color: 'danger',
        },
        {
          id: 1,
          title: 'Personal Responsibility',
          value: 20,
          footer: 'Provide required notes',
          color: 'primary',
        },
      ],
    };
  },
  methods: {
    ...mapActions('adminLayout', ['changeSidebarActive', 'switchSidebar']),
    setActiveByRoute() {
      const paths = this.$route.fullPath.split('/');
      paths.pop();
      this.changeSidebarActive(paths.join('/'));
    },
    sidebarMouseEnter() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(false);
        this.setActiveByRoute();
      }
    },
    sidebarMouseLeave() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      }
    },
  },
  created() {
    this.setActiveByRoute();
  },
  computed: {
    ...mapState('adminLayout', {
      sidebarStatic: state => state.sidebarStatic,
      sidebarOpened: state => !state.sidebarClose,
      activeItem: state => state.sidebarActiveElement,
    }),
  },
};
</script>

<!-- Sidebar styles should be scoped -->
<style src="./Sidebar.scss" lang="scss" scoped/>
